<template>
  <div class="role">
    <div class="topBox">
      <p>角色类型:
        <Select v-model="roleType" @on-change="changeRoleType" style="width:200px">
          <Option v-for="item in roleTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </p>
      <Button type="primary" class="basicBtn" custom-icon="iconfont icon-jia" @click="addRole">新建角色</Button>
    </div>
    <div class="mainBox">
      <div class="pcBox" v-show="roleType==1">
        <Table :height="tableHeight1" ref="table1" :columns="columns1" :data="data1"></Table>
        <div class="pageBox">
          <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize"/>
        </div>
      </div>
      <div class="wxBox" v-show="roleType==3">
        <Table :height="tableHeight2" ref="table2" :columns="columns2" :data="data2"></Table>
        <div class="pageBox">
          <Page :total="total2" :transfer='true' show-elevator show-sizer @on-change="changePage2" @on-page-size-change="changePageSize2"/>
        </div>
      </div>
    </div>
    <Modal 
      class="infoModal"
        :name="modelName"
        v-model="modal1"
        :title="modelTitle"
        @on-ok="ok"
        @on-cancel="cancel">
        <p><Icon :custom="modeIcon" :color="iconColor"></Icon> {{modelContent}}</p>
    </Modal>
    <Modal 
        width="60%"
        :name="modelName"
        v-model="modal2"
        :title="modelTitle"
        @on-ok="confirm"
        @on-cancel="cancel">
        <div class="accountBox">
          <ul>
            <li>
              <p class="redsize">角色类型:</p>
              <p>
                <Select v-model="roleSelType" @on-change="changeRole" style="width:200px">
                  <Option v-for="item in roleSelTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </p>
            </li>
            <li>
              <p class="redsize">名称:</p>
              <Input v-model="roleName" placeholder="姓名" style="width: 300px" />
            </li>
            <li>  
              <p class="redsize">编号:</p>
              <Input v-model="roleNumber" placeholder="编号" style="width: 300px" />
            </li>
            <li class="redsize">  
              <p>排序:</p>
              <Input v-model="orderNum" placeholder="排序" style="width: 300px" />
            </li>
            <li>  
                <p class="redsize">菜单:</p>
                <div class="itemBox">
                  <span v-for="(item,index) in itemAList" @click="selectRole(item)" v-bind:key="index"><i class="iconfont" :class="{'icon-xuanzhong2':item.isSelect,'icon-weixuanzhong2':!item.isSelect} "></i>{{item.name}}</span>
                </div>
            </li>
            <li>  
              <p>状态:</p>
              <RadioGroup v-model="status" @on-change="changeSwitch(editId,status)">
                <Radio v-for="(item,index) in statusList"  v-bind:key="index" :label="item.value">{{item.label}}</Radio>
              </RadioGroup>
            </li>
          </ul>
        </div>
        <div slot="footer">
            <Button type="text" size="large" @click="cancel">取消</Button>
            <Button type="primary" size="large" @click="confirm">确定</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import { 
  getOrderDetail,roleList,
  hospitalItem,saveRole,
  roleSelect,updRole,
  roleStatus,roleDetail,
  deleteRole
} from "./../../api/system";
import { tips } from "../../tools";
export default {
  name: 'RoleManager',
  data () {
    return {
      tableHeight1:602,
      tableHeight2:602,
      editId:0,
      roleType:1,
      roleTypeList:[
        {
          label:'PC',
          value:1
        },
        {
          label:'微信',
          value:3
        }
      ],
      //分页
      iconShow:'',
      total:0,
      pageCurrent:1,
      pageSize: 10,
      total2:0,
      pageCurrent2:1,
      pageSize2: 10,
      //弹出框内容
      roleNumber:'',
      roleName:'',
      orderNum:0,
      roleSelType:1,//角色类型
      roleSelTypeList:[
        {
          label:'PC',
          value:1
        },
        {
          label:'微信',
          value:3
        }
      ],
      itemAList:[],
      roleSelItems:[],//所选权限菜单
      status:1,//状态
      statusList:[
        {
          label:'启用',
          value:1
        },
        {
          label:'停用',
          value:0
        }
      ],
      pcRole:'医生',
      wechatRole:'管理员',
      modelName:'',
      modeIcon:'',
      iconColor:'',
      modelTitle:'',
      modelContent:'',
      modal1:false,
      modal2:false,
      allItems:[],//查询所有显示菜单
      itemArr:[
        '7', '9','10',
        '11','12','13',
        '14','15','16',
      ],
      columns1:[
        {
            title: '名称',
            key: 'name',
            align:'center'
        },
        {   
            title: '编码',
            key: 'code',
            align:'center'
        },
        {
            title: '状态',
            key: 'enabled',
            align:'center',
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps:{
                innerHTML:params.row.enabled=='1'?'已启用':'未启用' 
              }
            },
            )
          } 
        },
        {
          title: '预约挂号',
          align:'center',
          key: 7,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[7]==true?'block':'none'
                }
              })
            ])
              
          }
        },
        {
            title: '门诊',
            align:'center',
            key: 9,
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[9]==true?'block':'none'
                }
              })
            ])
              
          }
        },
        {
          title: '收费',
          align:'center',
          key: 10,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[10]==true?'block':'none'
                }
              })
            ])
          }
        },
        {
          title: '检测项目',
          align:'center',
          key: '11',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[11]==true?'block':'none'
                }
              })
            ])
          }
        },
        {
          title: '药房',
          align:'center',
          key: 12,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[12]==true?'block':'none'
                }
              })
            ])
          }
        },
        {
          title: '患者管理',
          align:'center',
          key: 13,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[13]==true?'block':'none'
                }
              })
            ]) 
          }
        },
        {
          title: '数据统计',
          align:'center',
          key: 14,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[14]==true?'block':'none'
                }
              })
            ])
          }
        },
        {
          title: '系统管理',
          align:'center',
          key: 15,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[15]?'block':'none'
                }
              })
            ])
          }
        },
        {
          title: '外送项目结算',
          align:'center',
          key: 16,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[16]?'block':'none'
                }
              })
            ])
          }
        },
        {
          width:180,
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          // maxWidth:170,
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center',
                  display:'flex',
                  flexFlow:'wrap row'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-bianji'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:params.row.managerFlag==1?'#DFDFE9':'#2778E7',
                    color:params.row.managerFlag==1?'#DFDFE9':'#2778E7'
                  },
                  domProps:{
                    disabled:params.row.managerFlag==1?true:false
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.roleName = '';
                      this.roleNumber = '';
                      this.roleName = '';
                      this.roleNumber = '';
                      this.modal2 = true;
                      this.modelName = 'editRole';
                      this.modelTitle = '修改角色';
                      this.roleSelType = this.roleType;
                      this.editId = params.row.id;
                      console.log(this.editId)
                      this.roleDetailList();
                    }
                  }
                }, '修改'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shanchu'
                  },
                  style: {
                    textAlign:'center',
                    borderColor:params.row.managerFlag==1?'#DFDFE9':'#c9c9c9',
                    color:params.row.managerFlag==1?'#DFDFE9':'#595757'
                  },
                  domProps:{
                    disabled:params.row.managerFlag==1?true:false
                  },
                  on: {
                    click: () => {
                      this.modal1 = true;
                      this.modelName = 'delete';
                      this.modelTitle = '系统提示';
                      this.modelContent = '是否确认删除该角色?此操作不可逆';
                      this.modeIcon = ' iconfont icon-Group-';
                      this.iconColor='#FE6E6E';
                      this.deleteId = params.row.id;
                      console.log(this.deleteId)
                    }
                  }
                }, '删除')
            ]);
          }
        }
      ],
      data1:[
      ],
      columns2:[
        {
            title: '名称',
            key: 'name',
            align:'center'
        },
        {   
            title: '编号',
            key: 'code',
            align:'center'
        },
        {
            title: '状态',
            key: 'enabled',
            align:'center'
        },
        {
          title: '我的预约',
          align:'center',
          key: 1,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[1]==true?'block':'none'
                }
              })
            ])
              
          }
        },
        {
            title: '支付',
            align:'center',
            key: 2,
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[2]==true?'block':'none'
                }
              })
            ])
              
          }
        },
        {
          title: '订单',
          align:'center',
          key: 3,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[3]==true?'block':'none'
                }
              })
            ])
          }
        },
        {
          title: '统计',
          align:'center',
          key: 4,
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row[4]==true?'block':'none'
                }
              })
            ])
          }
        },
        {
          title: '医院',
          align:'center',
          key: '5',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row['5']==true?'block':'none'
                }
              })
            ])
          }
        },
        {
          title: '检测目录',
          align:'center',
          key: '6',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                color:'#FE6E6E'
              }
            },
            [
              h('Icon',{
                props:{
                  custom:'iconfont icon-duihao'
                },
                style:{
                  textAlign:'center',
                  display:params.row['6']==true?'block':'none'
                }
              })
            ]) 
          }
        },
        {
          width:180,
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          // maxWidth:170,
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center',
                  display:'flex',
                  flexFlow:'wrap row'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-bianji'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:params.row.managerFlag==1?'#DFDFE9':'#2778E7',
                    color:params.row.managerFlag==1?'#DFDFE9':'#2778E7'
                  },
                  domProps:{
                    disabled:params.row.managerFlag==1?true:false
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.roleName = '';
                      this.roleNumber = '';
                      this.modal2 = true;
                      this.modelName = 'editRole';
                      this.modelTitle = '修改角色';
                      this.editId = params.row.id;
                      console.log(this.editId)
                      this.roleDetailList();
                    }
                  }
                }, '修改'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shanchu'
                  },
                  style: {
                    textAlign:'center',
                    borderColor:'#FE6E6E',
                    color:'#FE6E6E'
                  },
                  attrs:{
                    disabled:params.row.managerFlag==1?true:false
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal1 = true;
                      this.modelName = 'delete';
                      this.modelTitle = '系统提示';
                      this.modelContent = '是否确认删除该角色?此操作不可逆';
                      this.modeIcon = ' iconfont icon-Group-';
                      this.iconColor='#FE6E6E';
                      this.itemAList = [];
                      this.deleteId = params.row.id;
                      console.log(this.deleteId)
                    }
                  }
                }, '删除')
            ]);
          }
        }
      ],
      data2:[]
    }
  },
  created(){
    let lett = this;
    document.onkeydown = function(e) {
    let key = window.event.keyCode;
    if (key == 13) {
      lett.search();
      }
    }
  },
  mounted(){
    window.addEventListener('resize', this.getTableHeight);
    this.getTableHeight();
    this.loadList();
  },
  methods:{
    getTableHeight(){
      // 设置表格高度 
      this.tableHeight1 = window.innerHeight - this.$refs.table1.$el.offsetTop-90; 
      this.tableHeight2 = window.innerHeight - this.$refs.table2.$el.offsetTop-90; 

    },
    loadList(){
      this.itemsList();
      this.search();
    },
    //查询
    search(){
      let _this = this;
      roleList({
        category:_this.roleType,
        current: _this.pageCurrent,
        size: _this.pageSize
      }).then(res => {
        console.log(res);
        let data = res.records;
        // _this.data1 = res.records;
        // console.log(_this.allItems);
        // console.log(data)
        _this.total = res.total;
        let hospitalMenuList = [];
        let arr = [];
        let obj = {
          name:'',
          code:'',
          enabled:'',
          id:0
        };
        // console.log(data)
        for(let i=0;i<data.length;i++){
          let subArr ={};
          let items = data[i].hospitalMenuList;
            console.log(items)
            for(let j=0;j<items.length;j++){
              //let index = items.findIndex(target=>target.id==_this.allItems[j].id);
              let index = _this.allItems.findIndex(target=>target.id==items[j].id);
          
              // console.log(index); 
              // console.log(_this.allItems[j]);
              if(index>-1){
                // console.log(_this.allItems[index].id)
                subArr[_this.allItems[index].id] = true;
                subArr.name = data[i].name;
                subArr.code = data[i].code;
                subArr.enabled = data[i].enabled;
                subArr.id = data[i].id;
                subArr.managerFlag = data[i].managerFlag;
                // console.log(subArr);
              }else{

              }
            }
            arr.push(subArr);
          }
          // console.log(subArr);
        _this.data1 = arr;
        _this.data2 = arr;
        console.log(arr)
        
      });
    },
    //所有列表显示菜单权限查询
    itemsList(){
      let _this = this;
      hospitalItem({
        catrgory: _this.roleType
      }).then(res => {
        console.log(res);
        _this.allItems = res;
        let arr = [];
        res.forEach(item => {
          let obj={
            id:'',
            name:'',
            isSelect:false
          }
          obj.id = item.id;
          obj.name = item.name;
          arr.push(obj);
        });
        console.log(arr)
        _this.itemAList = arr;
      });
    },
    // //新增修改所有菜单权限
    // itemAllList(){
    //   let _this = this;
    //   roleSelect({
    //     catrgory: _this.roleSelType
    //   }).then(res => {
    //     console.log(res);
    //     let arr = res;
    //     for(let i=0;i<arr.length;i++){
    //       arr[i].isSelect = false;
    //     }
    //     console.log(arr);
    //     _this.itemAList = arr;
    //   });
    // },
    //选中菜单
    selectRole(data){
      console.log(data)
      if(data.isSelect){
        data.isSelect = false;
      }else{
        data.isSelect = true;
      }
      let arr = [];
      let itemAList = this.itemAList; 
      console.log(itemAList)
      for(let i=0;i<itemAList.length;i++){
        if(itemAList[i].isSelect==true){
          arr.push(itemAList[i].id)
        }
      }console.log(arr);
      this.roleSelItems = arr;
    },
    ok(){
      let _this = this;
      deleteRole({
        id:_this.deleteId
      }).then(res => {
        console.log(res); 
        tips(_this, res, "success");
        _this.loadList();
      });
    },
    cancel(){
      this.modal2 =false;
    },
    //改变角色类型查询
    changeRoleType(value){
      console.log(value);
      switch(value){
        case 1:
          this.roleType = 1;
          this.loadList();
          break;
        case 3:
          this.roleType = 3;
          this.loadList();
          break;
      }
    },
    //新增修改弹出框改变角色类型
    changeRole(value){
      console.log(value)
      switch(value){
        case 1:
          this.roleSelType = 1;
          this.itemsList();
          break;
        case 3:
          this.roleSelType = 3;
          this.itemsList();
          break;
      }
    },
    //新增角色·
    addRole(){
      this.modal2 = true;
      this.modelName = 'newRole';
      this.modelTitle = '新建角色';
      this.roleSelType = this.roleType;
      this.itemsList();
      this.roleName = '';
      this.roleNumber = '';
    },
    //确认新建
    confirm(){
      let _this = this;
      // _this.model2 =false;
      switch(this.modelName){
        case 'newRole':
          if(_this.roleNumber==''){
            _this.modal2 =true;
          }else if(!_this.roleSelItems.length<0){
            _this.modal2 =true;
          }else if(_this.roleName==''){
            _this.modal2 =true;
          }else{
            saveRole({
              category: _this.roleSelType,
              code: _this.roleNumber,
              ids: _this.roleSelItems,
              name: _this.roleName,
              orderNum: _this.orderNum
            }).then(res => {
              _this.modal2 =false;
              console.log(res);
              tips(_this, res, "success");
              _this.loadList();
            });
          }
          break;
        case 'editRole':
          console.log(_this.roleSelItems);
          updRole({
            id:_this.editId,
            category: _this.roleSelType,
            code: _this.roleNumber,
            ids: _this.roleSelItems,
            name: _this.roleName,
            orderNum: _this.orderNum
          }).then(res => {
            _this.modal2 =false;
            console.log(res);
            tips(_this, res, "success");
            _this.loadList();
          });
          break;
      }
    },
    //id查询角色详情
    roleDetailList(){
      let _this = this;
      roleDetail({
        id:_this.editId
      }).then(res => {
        console.log(res); 
        _this.roleName = res.name;
        _this.roleNumber = res.code;
        for(let i =0;i<_this.itemAList.length;i++){
          _this.itemAList[i].isSelect = false;
        }
        //页面显示
        if(res.hospitalMenuList.length>0){
          for(let i =0;i<res.hospitalMenuList.length;i++){
            let pcIndex = _this.itemAList.findIndex(target=>target.id==res.hospitalMenuList[i].id);
            // console.log(pcIndex)
            // console.log(_this.itemAList)
            if(pcIndex!=-1){
              _this.itemAList[pcIndex].isSelect = true;
            }
          }
          console.log(_this.itemAList)
        }
        //传值
        let pcArr = [];
        let itemAList = this.itemAList; 
        console.log(itemAList)
        for(let i=0;i<itemAList.length;i++){
          if(itemAList[i].isSelect==true){
            pcArr.push(itemAList[i].id)
          }
          // wechatSelRole
          
          _this.roleSelItems = pcArr;
        }
        console.log(pcArr);
      });
    },
    //改变状态
    changeSwitch(id,enabled){
      let _this = this;
      roleStatus({
        id:id,
        enabled:enabled
      }).then(res => {
        tips(_this, res, "success");
        // _this.loadList();
      });
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
    //改变页码
    changePage2(current){
      this.pageCurrent2 = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize2(size){
      this.pageSize2 = size;
      this.loadList();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.role{
  height: 100%;
  padding: 10px;
}
.topBox{
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap row;
  padding-bottom:10px;
}
.topBox>p{
  font-size: 16px;
}
.topBox>p>div{
  margin-left: 5px;
}
.topBox button{
  margin-left: 20px;
}
.pageBox{
  text-align: center;
  padding: 5px 0;
}
.ivu-modal-body p{
  font-size: 14px;
}
/* 新建账户框 */
.accountBox>ul>li{
  display: flex;
  justify-content: baseline;

}
.accountBox>ul>li>p:first-child{
  width: 150px;
  height: 41px;
  padding: 10px;
}
.accountBox>ul>li>p{
  padding: 10px 0;
}
.accountBox>ul>li>p>span.block{
  display: block;
  color: #FE6E6E;
}
.accountBox>ul>li>div>span>i{
  color: #1955A8;
}
.accountBox>ul>li>div.itemBox{
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap row;
  padding: 10px 0 10px 0;
}
.accountBox>ul>li>div.itemBox>span{
  margin-right: 15px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/system/RoleManager.vue